import React from "react";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { findIcon } from "../../views/dashboard/icons";
import "../../assets/scss/customizer/components/react-calendar/_react-calander.scss";

const ReactCalender = ({ events, tooltip = "" }) => {
  const graphTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {tooltip}
    </Tooltip>
  );

  return (
    <Card>
      <Card.Header className="d-flex gap-2 align-items-center">
        <h5 className="mb-0">Calendar</h5>
        {!!tooltip && (
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 50, hide: 200 }}
            overlay={graphTooltip}
          >
            <span className="text-primary cursor-pointer">
              {findIcon("info", "outline", 20)}
            </span>
          </OverlayTrigger>
        )}
      </Card.Header>
      <Card.Body>
        <FullCalendar
          plugins={[dayGridPlugin]}
          initialView="dayGridMonth"
          events={events}
          height="100%"
          aspectRatio={1.3}
          contentHeight="auto"
          dayMaxEventRows={3}
        />
      </Card.Body>
    </Card>
  );
};

export default ReactCalender;
